import PageLayout from "@/components/feature/PageLayout";
import { Link } from "react-router-dom";

export default function UnrecognizedChargePage() {
  return (
    <PageLayout>
      <div className="bg-white rounded-2xl border border-gray-200 p-8">
        <div className="mb-1">
          <span className="text-xs font-bold uppercase tracking-widest text-gray-400">Billing &amp; Payments</span>
        </div>
        <h2 className="text-xl font-bold text-gray-900 mb-4">I don&apos;t recognize this charge — what should I do?</h2>
        <div className="space-y-4 text-sm">
          <p className="text-gray-500">
            Seeing an unfamiliar charge on your statement can be alarming. Here&apos;s how to identify and resolve it quickly.
          </p>
          <h4 className="font-semibold text-gray-800">First, check these things:</h4>
          <ul className="list-disc list-inside space-y-2 text-gray-500">
            <li>The charge may appear as <strong className="text-gray-700">&quot;Kingcraft Technologies LTD&quot;</strong> or <strong className="text-gray-700">&quot;kingcraftech.com&quot;</strong> on your statement</li>
            <li>Check your email inbox (including spam) for a receipt from us</li>
            <li>Ask family members or others who may have access to your card</li>
            <li>Check if you signed up for a free trial that converted to a paid subscription</li>
          </ul>
          <h4 className="font-semibold text-gray-800">If you still don&apos;t recognize it:</h4>
          <ol className="list-decimal list-inside space-y-2 text-gray-500">
            <li>Contact our support team immediately with the charge amount and date</li>
            <li>We will investigate and provide full details within 1–2 business days</li>
            <li>If the charge is confirmed as unauthorized, we will issue a full refund</li>
          </ol>
          <div className="bg-amber-50 border border-amber-200 rounded-xl p-4">
            <p className="text-sm text-amber-800">
              <strong>Important:</strong> Do not file a chargeback with your bank before contacting us — we can resolve most issues faster and without the hassle of a bank dispute.
            </p>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-gray-100 flex flex-col sm:flex-row gap-3">
          <Link to="/contact-support" className="inline-block bg-[#2d2f36] text-white px-5 py-2.5 rounded-xl text-sm font-semibold hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer text-center">
            Contact Support
          </Link>
          <Link to="/dispute-resolution" className="inline-block border border-gray-200 text-gray-700 px-5 py-2.5 rounded-xl text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer text-center">
            Submit a Dispute Form
          </Link>
        </div>
      </div>
    </PageLayout>
  );
}
